export class CookieKey{
    // cookie keywords
    static gemlpb_explorer_currdir = "gemlpb_explorer_currdir";
    static gemlpb_explorer_sortby = "gemlpb_explorer_sortby";
    static gemlpb_explorer_sortinc = "gemlpb_explorer_sortinc";
    static quotakb_free = 10240;
}